import { Invoice } from '@models/invoice/invoice.model';
// Do not shorten this import because it throws
// Cannot read properties of undefined (reading 'invoiceStatusGroups')
import { invoiceStatusGroups } from '../../../../../../../../shared/components/invoice-status-tabs/invoice-status-tabs.component';

export const parcelReceivedStatuses = [...invoiceStatusGroups.received];
export const trackedParcelRemovedStatuses = [2, 3];
export const trackedParcelReceivedStatuses = [...invoiceStatusGroups.received];
export const parcelStatusesForThirdPersonPayer = [1, 2, 3, 9, 10, 11, 106];

export function parcelReceived(parcel: Invoice): boolean {
  return parcelReceivedStatuses.some(s => s === Number(parcel.statusCode));
}

export function trackedInvoiceRemoved(parcel: Invoice): boolean {
  return trackedParcelReceivedStatuses.some(s => s === Number(parcel.statusCode)) ||
    trackedParcelRemovedStatuses.some(s => s === Number(parcel.statusCode));
}

export function parcelNotFound(parcel: Invoice): boolean {
  return trackedParcelRemovedStatuses.some(s => s === Number(parcel.statusCode));
}

export function awaitingParcel(parcel: Invoice): boolean {
  return parcel.statusCode === '1';
}

export function invalidStatusCode(parcel: Invoice): boolean {
  return !parcel.statusCode;
}

export function allowPayAsThirdPerson(parcel: Invoice): boolean {
  const statusCodeForThirdPersonPayer = parcel.statusCode && parcelStatusesForThirdPersonPayer.every(s => s !== Number(parcel.statusCode));
  const counterpartyIsPrivatePerson = parcel.CounterpartyType === 'PrivatePerson';
  const payerTypeIsRecipient = parcel.PayerType === 'Recipient';
  const paymentMethodIsCash = parcel.paymentMethod.id === 'Cash';
  const paymentStatusIsEmpty = parcel.PaymentStatus === '';

  return statusCodeForThirdPersonPayer
    && counterpartyIsPrivatePerson
    && payerTypeIsRecipient
    && paymentMethodIsCash
    && paymentStatusIsEmpty;
}
